import { FC, ReactElement } from 'react';

import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import clsx from 'clsx';

import { IPageLoaderProps } from './types';

import styles from './PageLoader.module.scss';

export const PageLoader: FC<IPageLoaderProps> = ({ contained = false }): ReactElement => (
  <Backdrop
    sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}
    className={clsx({ [styles.containedLoader]: contained })}
    open
    invisible
  >
    <CircularProgress color="primary" />
  </Backdrop>
);
